/** how many pixels the items of a row may be wider than their container, from rounding */
const ROUNDING = 1;

export default class ElementSize {
    /**
     *
     * @param element
     * @returns float
     */
    static getOuterWidth(element) {
        var domRect = element.getBoundingClientRect();
        let computedStyle = getComputedStyle(element);
        let marginLeft = parseFloat(computedStyle.marginLeft);
        let marginRight = parseFloat(computedStyle.marginRight);
        return domRect.width + marginLeft + marginRight;
    }

    /**
     * The gap between the columns of a flex or grid container, 0 for none (or no element).
     *
     * @param element
     * @returns float
     */
    static getColumnGap(element) {
        if (!element) {
            return 0;
        }
        const gap = parseFloat(getComputedStyle(element).columnGap);
        return isNaN(gap) ? 0 : gap;
    }

    /**
     * Tries to find out, how many elements we can fit into the container so
     * they do not wrap.
     *
     * @param containerElement
     * @param element
     * @param numberOfRows
     * @returns {number}
     */
    static calclateNumberOfFittingItemsPerSlide(containerElement, element, numberOfRows) {

        if (null == element || containerElement == null) {
            return 1;
        }

        var domRect = containerElement.getBoundingClientRect();
        // n items and the n - 1 gaps between them have to fit: the row of the simple thumbnails, the
        // grid and the squares lay their items out with a gap (until 7.0.0 the thumbnails floated
        // with a margin, which getOuterWidth() counts)
        // up to a pixel of rounding is allowed: a slide of Glide is as wide as the rounded
        // offsetWidth of the slider, so the items in it are a fraction wider than the slider
        // measures (309.6 px for two squares of 154 px and a gap of 2 px)
        const gap = ElementSize.getColumnGap(element.parentElement);
        let numberOfItemsPerSlide = Math.floor((domRect.width + gap + ROUNDING) / (ElementSize.getOuterWidth(element) + gap)) * numberOfRows;


        if (numberOfItemsPerSlide < 1) {
            numberOfItemsPerSlide = 1 * numberOfRows;
        }

        return numberOfItemsPerSlide;
    }
}
